(function() {
  'use strict';

  function initWishlistPage(swat) {
    var grid = document.getElementById('swym-wishlist-grid');
    if (!grid) return;

    // Share modal logic
    var shareBtn = document.getElementById('swym-share-btn');
    var modal = document.getElementById('swym-share-modal');
    var closeBtn = document.getElementById('swym-modal-close');
    var copyBtn = document.getElementById('swym-copy-link');
    var fbBtn = document.getElementById('swym-share-fb');
    var xBtn = document.getElementById('swym-share-x');

    if (shareBtn) {
      shareBtn.addEventListener('click', function() {
        // Only fetch share URL when button is clicked
        try {
          if (swat.shareWishList) {
            swat.shareWishList({}, function(data) {
              var shareUrl = (data && (data.su || data.shareUrl)) || window.location.href;
              setupModalButtons(shareUrl);
            });
          } else {
            setupModalButtons(window.location.href);
          }
        } catch(e) {
          setupModalButtons(window.location.href);
        }
        modal.classList.add('active');
      });
    }

    function setupModalButtons(shareUrl) {
      if (copyBtn) {
        copyBtn.onclick = function() {
          navigator.clipboard.writeText(shareUrl).then(function() {
            copyBtn.textContent = '✓ Copied!';
            setTimeout(function() { copyBtn.innerHTML = '&#128279; Copy Link'; }, 2500);
          });
        };
      }
      if (fbBtn) {
        fbBtn.onclick = function() {
          window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(shareUrl), '_blank');
        };
      }
      if (xBtn) {
        xBtn.onclick = function() {
          window.open('https://twitter.com/intent/tweet?url=' + encodeURIComponent(shareUrl), '_blank');
        };
      }
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        modal.classList.remove('active');
      });
    }

    if (modal) {
      modal.addEventListener('click', function(e) {
        if (e.target === modal) modal.classList.remove('active');
      });
    }

    // Fetch and render wishlist products
    swat.fetch(function(products) {
      if (!products || products.length === 0) {
        grid.innerHTML = '<p>Your wishlist is empty.</p>';
        return;
      }

      grid.innerHTML = products.map(function(product) {
        return '<div class="swym-wishlist-card">' +
          '<a href="' + product.du + '">' +
          '<img src="' + product.iu + '" alt="' + product.dt + '">' +
          '</a>' +
          '<h3><a href="' + product.du + '">' + product.dt + '</a></h3>' +
          '<p>$' + parseFloat(product.pr).toFixed(2) + '</p>' +
          '<button class="swym-atc-btn" data-id="' + product.epi + '">+ Add to Cart</button>' +
          '</div>';
      }).join('');

      grid.querySelectorAll('.swym-atc-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(btn.dataset.id), quantity: 1 })
          }).then(function() {
            btn.textContent = 'Added!';
            setTimeout(function() { btn.textContent = '+ Add to Cart'; }, 2000);
          });
        });
      });
    });
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(initWishlistPage);
})();